import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { TcsmStates } from '../../root/tcsm-model';
import { getTcsmEpiContent, setEpiContent, unloadEpiContent } from '../ducks/epi-api';
import { TcsmSiteSettingsProps } from '../models/epi-model';
import { BasePageModel, PageType, TcsmNotFoundPage } from '../models/tcsm-page-models';

export function useEpiPageContent(pathOverride?: string) {

    const language = useSelector<TcsmStates, string>(state => state.globalization?.currentlanguage);
    const pageData = useSelector<TcsmStates, BasePageModel>(state => state.epiProps?.pageData?.epiContent);
    const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);
    const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);
    const location = useLocation();

    const path = pathOverride || location?.pathname;

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(unloadEpiContent());
        dispatch(getTcsmEpiContent(
            path,
            language,
            { guid },
            (data) => dispatch(setEpiContent(data)),
            () => dispatch(setEpiContent(
                {
					pageType: PageType.NotFoundPage,
                    pageTitle: siteSettings?.error404Title,
                    mainContent: siteSettings?.error404,
                } as TcsmNotFoundPage))));
    }, [path]);

    return pageData;
}